export enum PreferencesPathTypeEnum {
  onlyPoint = 'only-point',
  directionPath = 'direction-path',
  animatedPath = 'animated-path',
}
